import { Controller } from "@hotwired/stimulus"

// Review rows editor (Settings → Facility page): add/remove {name, text}
// testimonial rows. Inputs use array-style names
// (facility_page[reviews][][name]) so the server receives an ordered array; the
// server normalizes and drops blank rows, and a hidden "" sentinel means
// removing every row simply clears the list. Progressive enhancement: the
// server-rendered rows post fine without JS — you just can't add/remove rows
// client-side.
export default class extends Controller {
  static targets = ["rows", "template"]

  add(event) {
    event.preventDefault()
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-review-row]").remove()
  }
}
